import "@/App.css";
import { Toaster } from "sonner";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import StudentLogin from "@/pages/StudentLogin";

import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminSchools from "@/pages/admin/Schools";
import AdminSchoolProfile from "@/pages/admin/SchoolProfile";
import AdminStudents from "@/pages/admin/Students";
import AdminStudentDetail from "@/pages/admin/StudentDetail";
import AdminCategories from "@/pages/admin/Categories";
import AdminQuestions from "@/pages/admin/Questions";
import AdminCoupons from "@/pages/admin/Coupons";
import AdminAnalytics from "@/pages/admin/Analytics";

import SchoolDashboard from "@/pages/school/SchoolDashboard";
import SchoolStudents from "@/pages/school/Students";
import SchoolAssignTest from "@/pages/school/AssignTest";
import SchoolReports from "@/pages/school/Reports";
import SchoolAnalytics from "@/pages/school/Analytics";

import StudentDashboard from "@/pages/student/StudentDashboard";
import StudentTestPage from "@/pages/student/TestPage";

function App() {
  return (
    <div className="App">
      <Toaster richColors position="top-right" closeButton />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />

            <Route
              path="/admin/login"
              element={<AdminLogin expectedRole="super_admin" />}
            />
            <Route
              path="/school/login"
              element={<AdminLogin expectedRole="school_admin" />}
            />
            <Route path="/student/login" element={<StudentLogin />} />

            {/* Super admin */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute roles={["super_admin"]}>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="schools" replace />} />
              <Route path="schools" element={<AdminSchools />} />
              <Route path="schools/:id" element={<AdminSchoolProfile />} />
              <Route path="students" element={<AdminStudents />} />
              <Route path="students/:id" element={<AdminStudentDetail />} />
              <Route path="categories" element={<AdminCategories />} />
              <Route path="questions" element={<AdminQuestions />} />
              <Route path="coupons" element={<AdminCoupons />} />
              <Route path="analytics" element={<AdminAnalytics />} />
            </Route>

            {/* School admin */}
            <Route
              path="/school"
              element={
                <ProtectedRoute roles={["school_admin"]}>
                  <SchoolDashboard />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="students" replace />} />
              <Route path="students" element={<SchoolStudents />} />
              <Route path="assign-test" element={<SchoolAssignTest />} />
              <Route path="reports" element={<SchoolReports />} />
              <Route path="analytics" element={<SchoolAnalytics />} />
            </Route>

            <Route
              path="/student"
              element={
                <ProtectedRoute student>
                  <StudentDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/student/test/:categoryId"
              element={
                <ProtectedRoute student>
                  <StudentTestPage />
                </ProtectedRoute>
              }
            />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
